<template>
  <BasePopover trigger="hover">
    <div
      data-test="reference"
      slot="reference"
      class="select-none bg-primaryHover w-fit py-xs pl-xs pr-lg text-whiteOverride rounded-full flex items-center"
    >
      <CircleInfoIcon class="mr-base" />
      <span class="text-12">{{ $t('functional.info') }}</span>
    </div>
    <slot slot="popper-content" />
  </BasePopover>
</template>

<script>
import { CircleInfoIcon } from '@/components/icons/fontIcons';
import BasePopover from '@/components/library/popovers/BasePopover.vue';

export default {
  name: 'PopoverPill',
  components: {
    BasePopover,
    CircleInfoIcon,
  },
};
</script>

